export default {
  path: '/charging_packages',
  component: () => import('@/layouts/PublicLayout'),
  redirect: '/charging_packages/list',
  meta: {
    title: '我的充电包'
  },
  children: [
    {
      path: 'list',
      component: () => import('@/views/charging_package_definitions/ChargingPackages'),
      meta: {
        title: '我的充电包'
      }
    },
    {
      path: ':id',
      component: () => import('@/views/charging_package_definitions/Detail'),
      meta: {
        title: '充电包详情'
      }
    }
  ]
}
